import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import UUID from "vue-uuid"

const Plugin = {
  install () {

    Vue.use(VueLazyload, {
      observer: true,
      // preLoad: 1.2,
      // attempt: 3,
      // throttleWait: 200,
      // lazyComponent: true,
      // observerOptions: {
      //   threshold: 0.5,
      // },
    })
    Vue.use(UUID)

    Vue.prototype.$progress = new Vue()
    Vue.prototype.$notification = new Vue()

    console.log("plugins installed")
  }
}

export default Plugin